// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: Ttu0k4DUDe4y
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicDashboardCompletedStatusCard.module.css"; // plasmic-import: Ttu0k4DUDe4y/css

createPlasmicElementProxy;

export const PlasmicDashboardCompletedStatusCard__VariantProps = new Array();

export const PlasmicDashboardCompletedStatusCard__ArgProps = new Array();

const $$ = {};

function PlasmicDashboardCompletedStatusCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames(projectcss.all, projectcss.__wab_text, sty.text)}
      >
        {"Completed"}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDashboardCompletedStatusCard__ArgProps,
          internalVariantPropNames:
            PlasmicDashboardCompletedStatusCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDashboardCompletedStatusCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDashboardCompletedStatusCard";
  } else {
    func.displayName = `PlasmicDashboardCompletedStatusCard.${nodeName}`;
  }
  return func;
}

export const PlasmicDashboardCompletedStatusCard = Object.assign(
  // Top-level PlasmicDashboardCompletedStatusCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicDashboardCompletedStatusCard
    internalVariantProps: PlasmicDashboardCompletedStatusCard__VariantProps,
    internalArgProps: PlasmicDashboardCompletedStatusCard__ArgProps
  }
);

export default PlasmicDashboardCompletedStatusCard;
/* prettier-ignore-end */
